// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"714":"707c385e88","2643":"eb3fc579f2"}[chunkId] + ".chunk.css";
};